// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_index_menu__22ot8","menuItem":"Menu_index_menuItem__3MES4","swap":"Menu_index_swap__2McVH","edit":"Menu_index_edit__DpLur","active":"Menu_index_active__1V8SU"};